import { render, staticRenderFns } from "./UpdatePhone.vue?vue&type=template&id=6a29f73c&scoped=true&"
import script from "./UpdatePhone.vue?vue&type=script&lang=js&"
export * from "./UpdatePhone.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePhone.vue?vue&type=style&index=0&id=6a29f73c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a29f73c",
  null
  
)

export default component.exports